@if (inProgressCount() > 0 || errorCount() > 0) {
  <button id="operations-in-progress-open" type="button" class="operations-in-progress" (click)="openPanel()">
    @if (inProgressCount() > 0) {
      <sim-spinner class="operations-in-progress__spinner" buttonSpinner />
      <span class="operations-in-progress__label" i18n="@@OPERATIONS_IN_PROGRESS"
        >{{ inProgressCount() }} operations in progress</span
      >
    } @else {
      <sim-icon class="operations-in-progress__icon" icon="error_outline" [sizeInPx]="24" color="var(--danger)" />
      <span class="operations-in-progress__label" i18n="@@OPERATIONS_FAILED_COUNT"
        >{{ errorCount() }} operations failed</span
      >
    }
  </button>
}
